import * as React from "react";
import PropTypes from 'prop-types';

const SvgOrders = props => {
  if (props.id !== "_svgorders") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 40 40" fill="none" {...props}><path fill="#fff" d="M0 0h40v40H0z" /><path fillRule="evenodd" clipRule="evenodd" d="M15.678 14.168l12.225-4.21 4.2 1.442L20 15.706l-4.322-1.538zm8.031-5.648l-11.602 4.378-4.21-1.498L20 7.247l3.71 1.273zm-9.1 7.067l4.6 1.712v14.687l-11.25-5.25V13.112l3.9 1.452v6.877l2.75 1.126v-6.98zm6.075 17.917l12-5.572c.574-.266.941-.841.941-1.474V12.034c0-.698-.445-1.317-1.105-1.54l-12-4.052a1.625 1.625 0 00-1.04 0l-12 4.052a1.625 1.625 0 00-1.105 1.54v14.424c0 .633.367 1.208.94 1.474l12 5.572c.435.201.935.201 1.37 0zm11.358-6.768l-11.25 5.25V17.299l11.25-4.187v13.624z" fill="#E71324" /></svg>;
};

SvgOrders.displayName = "_svgorders";
SvgOrders.propTypes = {
  id: PropTypes.string
};
SvgOrders.defaultProps = {
  id: ''
};
export default SvgOrders;